// Minimal CSV parser: handles quoted fields, escaped quotes ("") and CRLF.
// The delimiter is auto-detected from the header line (comma, semicolon or tab).

export function detectDelimiter(text: string): string {
    const firstLine = text.split(/\r?\n/)[0] || "";
    const candidates = [",", ";", "\t"];
    let best = ",";
    let bestCount = 0;
    candidates.forEach(d => {
        const count = firstLine.split(d).length - 1;
        if (count > bestCount) {
            best = d;
            bestCount = count;
        }
    });
    return best;
}

export function parseCsv(text: string): { headers: string[]; rows: string[][] } {
    const delimiter = detectDelimiter(text);
    const records: string[][] = [];
    let record: string[] = [];
    let field = "";
    let inQuotes = false;

    for (let i = 0; i < text.length; i++) {
        const char = text[i];

        if (inQuotes) {
            if (char === '"' && text[i + 1] === '"') {
                field += '"';
                i++;
            } else if (char === '"') {
                inQuotes = false;
            } else {
                field += char;
            }
        } else if (char === '"' && field === "") {
            // Quotes only open a field at its start; a stray one (e.g. 27") is kept as text
            inQuotes = true;
        } else if (char === delimiter) {
            record.push(field);
            field = "";
        } else if (char === "\n" || char === "\r") {
            if (char === "\r" && text[i + 1] === "\n") {
                i++;
            }
            record.push(field);
            records.push(record);
            record = [];
            field = "";
        } else {
            field += char;
        }
    }

    if (field !== "" || record.length > 0) {
        record.push(field);
        records.push(record);
    }

    const nonEmpty = records.filter(r => r.some(cell => cell.trim() !== ""));
    const [headers = [], ...rows] = nonEmpty;
    return { headers: headers.map(h => h.trim()), rows };
}

export function toCsv(headers: string[], rows: string[][]): string {
    const escape = (value: string) => (/[",\n;]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value);
    return [headers, ...rows].map(r => r.map(escape).join(",")).join("\n");
}
